import { SwiperOptions } from "swiper/types";
import { queryAllHtmlElement } from "./base/query-all-html-element.ts";
import { queryHtmlElement } from "./base/query-html-element.ts";
import { BreakpointName, breakpointNames } from "./breakpoints.ts";
import { Expander } from "./components/expander/expander.ts";
import { Hero } from "./components/hero/hero.ts";
import { HoverBoxMap } from "./components/hover-box-map/hover-box-map.ts";
import { HeaderMainMenu } from "./components/menu/menu.ts";
import { Module } from "./components/module/module.ts";
import { ReturnToTop } from "./components/return-to-top/return-to-top.ts";
import { ClientsSwiper } from "./components/swiper/clients-swiper.js";
import { CustomSwiper } from "./components/swiper/custom-swiper.ts";
import { SyndicatedList } from "./components/syndicated-list/syndicated-list.ts";
import { Tiles } from "./components/tiles/tiles.ts";

const onReady = () => {
	// create animation when module contents enter viewport when scrolling
	queryAllHtmlElement(document, ".viewport-entry-animate").forEach(elModule => new Module(elModule));

	// create main menu functionality
	const elOpen = queryHtmlElement(document, ".header-main__menu-toggle");
	const elClose = queryHtmlElement(document, ".header-main__menu__close");
	const elMenu = queryHtmlElement(document, ".header-main__menu");
	if (elOpen !== null && elClose !== null && elMenu !== null) {
		new HeaderMainMenu({
			open: elOpen,
			close: elClose,
		}, elMenu);
	}

	// create hero banner functionality
	const elHero = queryHtmlElement(document, ".hero");
	if (elHero !== null) {
		new Hero(elHero);
	}

	// create 'Return To Top' functionality
	new ReturnToTop(document.querySelector(".return-to-top"), document.querySelector(".header-main"));

	// create content expanders functionality
	for (const elExpander of queryAllHtmlElement(document, ".expander--generic")) {
		const sizes = (elExpander.dataset['expanderSizes']?.split(" ") || [])
			.filter((size): size is BreakpointName => !!size && breakpointNames.includes(size as BreakpointName));
		new Expander(elExpander, sizes);
	}

	// create image map functionality
	for (const elHoverMap of [...document.querySelectorAll(".hover-map")].filter(el => el instanceof HTMLElement)) {
		const targets = [...elHoverMap.querySelectorAll(".hover-map__target")].filter(el => el instanceof Element);
		new HoverBoxMap(elHoverMap, targets);
	}

	// create swiper instances
	for (const el of queryAllHtmlElement(document, ".swiper--generic")) {
		// const config: {
		// 	grabCursor: boolean;
		// 	navigation?: { prevEl: Element | null, nextEl: Element | null };
		// 	on?: { init: () => void, resize: () => void };
		// } = {
		// 	grabCursor: true
		// };
		const config: SwiperOptions = {
			grabCursor: true,
		};

		// if parent node is '.swiper--generic__wrapper', configure any elements outside of the swiper
		if (el.parentElement?.classList.contains("swiper--generic__wrapper")) {
			// identify navigation buttons (prev/next)
			if ("navigation" in el.dataset) {
				config.navigation = {
					prevEl: queryHtmlElement(el.parentElement, ".swiper-button-prev"),
					nextEl: queryHtmlElement(el.parentElement, ".swiper-button-next"),
				};
			}
		}

		// // record tiles that have already been registered as Tile objects
		// const tileized = new Set();

		// // If this is a slider of tiles, create the Tile objects on init and on resize.
		// config.on = {
		// 	init: function () { // not arrow function! - need to create internal scope to inherit swiper instance
		// 		this.slides.each(slide => {
		// 			tileized.add(slide);
		// 			new Tiles(slide.querySelectorAll(".tile"));
		// 		});
		// 	},
		// 	resize: function () {
		// 		this.slides.each(slide => {
		// 			if (!tileized.has(slide)) {
		// 				tileized.add(slide);
		// 				new Tiles(slide.querySelectorAll(".tile"), true);
		// 			}
		// 		});
		// 	},
		// };

		new CustomSwiper(el, config);
	}

	// create 'Clients' swiper
	try {
		new ClientsSwiper();
	} catch {
		// fail silently
	}

	// Create syndicated list instances for reach appearance of a syndicated list
	queryAllHtmlElement(document, ".syndicated-list").forEach(elList => new SyndicatedList(elList));

	// Create expand functionality for bio profile slider
	//import BioListProfileExpander from "./js/components/bio-list-profile-expander/bio-list-profile-expander.ts";
	//for (const el of document.querySelectorAll(".swiper--bio-list .bio-list__profile")) {
	//	new BioListProfileExpander({
	//		elDescription: el.querySelector(".media__body__description"),
	//		elHeightDetector: el.querySelector(".media__body__description__height-detector"),
	//		elExpandButton: el.querySelector(".bio-list__profile__expand"),
	//	});
	//}

	// Create SVG replacements for lines within tiles so the text can scale based on the container size
	new Tiles(queryAllHtmlElement(document, ".tileset > .tile"));
	//new Tiles(document.querySelectorAll(".tileset > .tile"));
};

document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", onReady) : onReady();
